import { trackPageView } from '@openx/utils/lib/googleAnalytics.ts';
import { type JSX, useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router';
import { useDealLibraryListFetch } from '../../api/hooks/useDealLibraryListFetch.tsx';
import { ErrorPage } from '../../components/ErrorPage/ErrorPage.tsx';
import { DealLibraryList } from '../../modules/DealLibraryList/DealLibraryList.tsx';
import { Details } from '../../modules/Details/Details.tsx';

export const AppRoutes = (): JSX.Element => {
  const location = useLocation();
  const { dealTemplates, popularTags, isLoading, isError } = useDealLibraryListFetch();
  const [backButtonQueryParams, setBackButtonQueryParams] = useState(location.search);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  if (isError) {
    return <ErrorPage errorType={500} />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <DealLibraryList
            dealTemplates={dealTemplates}
            popularTags={popularTags}
            isLoading={isLoading}
            setQueryParamsForBackButton={setBackButtonQueryParams}
          />
        }
      />
      <Route
        path="/details/:id"
        element={<Details dealTemplates={dealTemplates} isLoading={isLoading} searchParams={backButtonQueryParams} />}
      />
      <Route path="*" element={<ErrorPage errorType={404} />} />
    </Routes>
  );
};
